export const GA_ID_TRAMITES = {
    RECEPCION_QUEJAS_CONVENIO_MLC: {
        nombreRNT: 'Recepción de Quejas Convenio Laboral Marítimo MLC 2006',
        category: 'Tramite digital',
        actionini: 'Inicio de la solicitud',
        actionfin: 'Fin de la solicitud',
        label: 'Tramite - ID 1100170051',
      },
    }

export default GA_ID_TRAMITES
